/* DOMNO. portal — THE ONE BOX at the top of Rewards.

   Copy is governed by Outputs/Rewards Portal/rewards-copy-deck.md. Do not invent lines here.

   ⚠ THIS IS THE MERGE. Dom, on his phone: the balance box said "1 FREE PIECE WAITING" and the
   drawer's own hero said "YOUR REWARD / FREE RING" directly underneath — two boxes saying the
   same thing. So this file now owns that slot for BOTH states, balance and picked, and it hides
   the drawer's `.hero`. One box, one thing to keep in sync.

   ⚠ THE SCHEME IS NEVER NAMED ON SITE. No "DOMNO. Rewards", no club. It is only ever "your free
   piece". Naming it makes it read as machinery, which is the exact thing 772 Trustpilot reviews
   praise this brand for not being. "The DOMNO. fam" is the email and social line only.

   ⚠ BANNED WORDS: unlock, redeem, points, tier, member, VIP, exclusive, claim, loyalty.
   `unlock` is on domno-voice's own never-list AND appears in zero customer reviews. "Tier" stays
   internal: the ladder is four pictures and is never called a tier out loud.

   ⚠ THE HEADLINE NAMES WHAT THEY CAN PICK RIGHT NOW — "one free ring" — and the word "waiting"
   is gone. "1 free piece waiting" made Dom stop and ask what it meant.

   ⚠ 14 Sep 2026 — NO WELCOME PIECE, AND REVIEWS NO LONGER PAY. Opening an account earns nothing:
   the first ORDER puts a piece in here and the SECOND order spends it. Two lines in here used to
   say otherwise and both were rewritten in the same push as the worker change — an empty box that
   says "leave a photo review and one lands here" is a promise the worker will not keep.

   Reads GET /api/credits?cid= and /cart.js for what they have already picked. That endpoint used
   to GRANT a welcome credit on first sight of a customer; it does not any more. */
(function(){
  var API = 'https://rewards.domno.com';
  var PRODUCT = 15982353908085;

  /* What their NEXT pick can be.

     ⚠ TURNED ON 10 Sep 2026, in the same change as domno-portal-ladder.js — and only because of
     it. The rule for weeks was that this stayed OFF: the picker built from ONE collection
     whatever step the customer had reached, so someone on step 3 was told "choose your free
     pendant" and would then have been shown 80 rings. Promising a category the picker cannot
     show is worse than saying ring.
     domno-portal-ladder.js repoints the picker at the right collection before it opens, so the
     promise is kept. IF THAT FILE IS EVER REMOVED OR STOPS LOADING, PUT THIS BACK TO false IN
     THE SAME BREATH.

     ⚠ 14 Sep 2026 — the rung now comes from ORDER COUNT (`step`), not from how many pieces they
     have used. And a birthday or referral piece is off the ladder entirely: the worker sets
     `free_choice` while one is in hand, and free choice means the noun is just "piece". */
  var TIERS_LIVE = true;
  var NOUNS = { 1:'ring', 2:'chain', 3:'pendant' };
  function nounFor(st){
    if (!TIERS_LIVE) return 'ring';
    if (st && st.free_choice) return 'piece';
    return NOUNS[Number(st && st.step)] || 'piece';
  }

  var WORDS = ['no','one','two','three','four','five','six','seven','eight','nine','ten'];
  function count(n){ return WORDS[n] || String(n); }

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function money(s){
    if (typeof window.dpMoney === 'function') return window.dpMoney(s);
    return s == null ? '' : String(s).replace(/<[^>]*>/g,'').trim();
  }
  function minSpend(gbp){
    if (typeof window.dpMinSpend === 'function') return window.dpMinSpend(gbp);
    var h = document.getElementById('dp-rings');
    return money((h && h.getAttribute('data-minspend')) || '£25');
  }

  function customerId(){
    try{
      if (window.DP_CUSTOMER && window.DP_CUSTOMER.id) return String(window.DP_CUSTOMER.id);
      if (window.__st && window.__st.cid) return String(window.__st.cid);
    }catch(e){}
    return '';
  }

  var state = null, picked = null, lastHtml = '';

  async function load(){
    var cid = customerId();
    if (!cid) return null;
    var email = '';
    try{ email = (window.DP_CUSTOMER && window.DP_CUSTOMER.email) || ''; }catch(e){}
    try{
      var r = await fetch(API + '/api/credits?cid=' + encodeURIComponent(cid) +
                          (email ? '&email=' + encodeURIComponent(email) : ''), { credentials:'omit' });
      var d = await r.json();
      return (d && d.ok) ? d : null;
    }catch(e){ return null; }
  }

  async function cartPick(){
    try{
      var c = await (await fetch('/cart.js', { headers:{ 'Accept':'application/json' } })).json();
      window.DP_CART = c;
      var line = (c.items||[]).filter(function(i){
        return i.product_id === PRODUCT || (i.properties && i.properties._reward_variant);
      })[0];
      if (!line) return null;
      var p = line.properties || {}, label = '';
      for (var k in p){ if (k.charAt(0) !== '_' && p[k] === 'FREE') label = k; }
      var name = p._reward_name || '', opts = p._reward_opts || '';
      if (!name && label){ var b = label.split(' · '); name = b.shift(); opts = b.join(' · '); }
      /* 14 Sep 2026 — the worth is looked up LIVE rather than read off the frozen
         `_reward_worth` property, which stays in pounds after a market switch. Charlie caught it
         testing in euros: everything else on the page converted and this one line did not.
         See dpWorthFor in domno-portal-money.js for why converting the stored number would be
         worse than the bug. */
      var worth = (typeof window.dpWorthFor === 'function')
        ? window.dpWorthFor(p._reward_variant, p._reward_worth)
        : money(p._reward_worth);
      return { name: name || 'your free piece', opts: opts, worth: worth };
    }catch(e){ return null; }
  }

  function html(){
    var min = minSpend(state.min_spend);
    var headline, sub, tone, mid = '';

    if (picked){
      tone = 'var(--red)';
      headline = picked.name;
      sub = (picked.opts ? esc(picked.opts) + ', ' : '') +
            (picked.worth ? 'worth ' + esc(picked.worth) + '. ' : '') +
            'yours free on this order over ' + esc(min) + '. pick another below to swap it.';
    } else {
      var n = state.balance || 0;
      var noun = nounFor(state);
      var free = !!state.free_choice;
      if (n === 0){
        /* Two different empty boxes, because they mean different things to the person reading.
           Someone who has never ordered needs to know where a piece comes from at all; someone
           who just spent theirs only needs to know another is coming. The old single line told
           both of them to leave a photo review, which stopped being true on 14 Sep. */
        tone = 'var(--ink)';
        if ((Number(state.orders) || 0) === 0){
          headline = 'nothing in here yet';
          sub = 'your first order puts a free piece in here, and you spend it on your next one. ' +
                'they don’t expire, so there’s no rush.';
        } else {
          headline = 'nothing in here right now';
          sub = 'your next order puts another one in here. they don’t expire, so there’s no rush.';
        }
      } else if (n === 1){
        tone = 'var(--red)';
        headline = 'one free ' + noun;
        if (free) mid = 'pick anything you like.';
        sub = 'pick yours below and it goes in your bag at £0. free on any order over ' +
              esc(min) + ', one per order, and they don’t expire.';
      } else {
        /* they are stacked up. The big line counts them, the small line says what the NEXT one
           is — the copy deck's "three free pieces" / "next one's a ring." Naming the piece is the
           whole point: "3 free pieces" alone made Dom ask what it meant. */
        tone = 'var(--red)';
        headline = count(n) + ' free pieces';
        mid = free ? 'next one’s any piece you like.' : 'next one’s a ' + esc(noun) + '.';
        sub = 'pick it below and it goes in your bag at £0, free on any order over ' +
              esc(min) + '. one per order, and they don’t expire.';
      }
    }

    return '<div style="background:var(--panel);border:1px solid var(--line);padding:18px 16px;' +
                'margin:0 0 16px;text-align:center">' +
             '<div style="color:var(--dim);font-size:10px;letter-spacing:.16em;text-transform:uppercase">' +
               (picked ? 'in your bag' : 'your rewards') + '</div>' +
             '<div style="font-family:var(--disp);font-weight:900;font-style:italic;font-size:28px;' +
                  'color:' + tone + ';margin:5px 0 7px;line-height:1.05;word-break:break-word">' +
               esc(headline) + '</div>' +
             (mid ? '<div class="c" style="text-transform:none;margin:0 0 6px;font-weight:700;' +
                    'color:var(--ink)">' + mid + '</div>' : '') +
             '<div class="c" style="text-transform:none;line-height:1.6;margin:0">' + sub + '</div>' +
           '</div>';
  }

  function render(){
    if (!state) return;
    var panel = document.getElementById('p-rewards');
    if (!panel) return;

    /* the drawer's own hero is the duplicate. Hidden, not deleted. */
    var hero = panel.querySelector('.hero');
    if (hero && hero.style.display !== 'none') hero.style.display = 'none';

    var host = panel.querySelector('[data-dp-credits]');
    var next = html();
    if (host && next === lastHtml) return;        /* idempotent — see gift.js on observer loops */

    if (!host){
      host = document.createElement('div');
      host.setAttribute('data-dp-credits','1');
      var thanks = panel.querySelector('[data-dp-thanks]');
      if (thanks && thanks.nextSibling) panel.insertBefore(host, thanks.nextSibling);
      else if (thanks) panel.appendChild(host);
      else panel.insertBefore(host, panel.firstChild);
    }
    host.innerHTML = next;
    lastHtml = next;
  }

  async function refresh(){
    var s = await load();
    if (s){ state = s; window.DP_CREDITS = s; }
    picked = await cartPick();
    render();
    /* the ladder reads the same numbers, so keep the two from disagreeing on screen */
    try{ if (typeof window.dpLadderRefresh === 'function') window.dpLadderRefresh(); }catch(e){}
  }

  async function boot(){
    await refresh();
    ['on:cart:change','on:cart:after-merge','on:line-item:change'].forEach(function(nm){
      document.addEventListener(nm, function(){ refresh(); });
    });
    var n = 0, iv = setInterval(function(){
      n++;
      var panel = document.getElementById('p-rewards');
      if (panel && !panel.querySelector('[data-dp-credits]')) render();
      if (n > 300) clearInterval(iv);
    }, 400);
  }

  window.dpCreditsRefresh = refresh;
  window.dpRewardNoun = function(){ return state ? nounFor(state) : 'ring'; };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();